import { useFormik } from 'formik';
import { pick } from 'lodash-es';
import { FC } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { useGetFeatureFlagsQuery } from '../../../../api/features';
import { businessInfoTwoValidationSchema } from '../../../../config/page-validation-schema';
import { FormikCurrencyField } from '../../../../general/inputs/formik-currency-field';
import { FormikTextField } from '../../../../general/inputs/formik-text-field';
import { RootState } from '../../../../store';
import { AddressFormFields } from '../../../address/components/address-form-fields';
import { AddressFormFieldsWithAutocomplete } from '../../../address/components/address-form-fields-with-autocomplete';
import { SubmitWorkflowButton } from '../../../workflow/components/submit-workflow-button';
import { businessPageTwoKeys, BusinessPageTwoPayload, saveBusinessInfoTwo } from '../../reducers/business-info';

const selector = ({
  businessInfo: { info },
  addressLookup: { loading: addressLoading },
  nextStep: { loading: appLoading },
}: RootState) => ({
  saving: addressLoading || appLoading,
  businessInfo: pick(info, businessPageTwoKeys),
});

const validationSchema = businessInfoTwoValidationSchema;

const BusinessInfoTwoForm: FC = () => {
  const { data: featureFlags } = useGetFeatureFlagsQuery();
  const dispatch = useDispatch();
  const { businessInfo, saving } = useSelector(selector);

  const formik = useFormik({
    initialValues: businessInfo,
    validationSchema,
    onSubmit: (values) => {
      const payload: BusinessPageTwoPayload = {
        ...values,
      };
      dispatch(saveBusinessInfoTwo(payload));
    },
    enableReinitialize: true,
  });

  return (
    <>
      <form onSubmit={formik.handleSubmit}>
        {!featureFlags?.qfEnableAddressAutocomplete && <AddressFormFields formik={formik} isPublic />}
        {featureFlags?.qfEnableAddressAutocomplete && <AddressFormFieldsWithAutocomplete formik={formik} isPublic />}
        <FormikCurrencyField
          formik={formik}
          id="annualRevenue"
          name="annualRevenue"
          label="Annual Business Revenue (Approximate)"
          inputProps={{ inputMode: 'numeric' }}
          data-public
        />
        <FormikCurrencyField
          formik={formik}
          id="monthlyFuelSpend"
          name="monthlyFuelSpend"
          label="Expected Monthly Fuel Spend"
          inputProps={{ inputMode: 'numeric' }}
          data-public
        />
        <FormikTextField
          formik={formik}
          id="fleetSize"
          name="fleetSize"
          label="# of Vehicles"
          type="number"
          data-public
        />
        <SubmitWorkflowButton type="submit" progress={saving} sx={{ mt: 3 }}>
          Next
        </SubmitWorkflowButton>
      </form>
    </>
  );
};

export { BusinessInfoTwoForm };
